// extracted by mini-css-extract-plugin
export default {"background":"header_background__reDdS","pageTitle":"header_pageTitle__CwN90"};